<main class="content-area">
    <app-edit-variables [(numericalmapxautovariables)]="plcProgramService.Program.numericalmapxautovariables"></app-edit-variables>

</main>
